import {
  Layers, Grid3X3, Bath, DoorOpen, ChefHat, Lightbulb, Sofa, TreePine,
} from "lucide-react";
import Reveal from "../components/Reveal";
import { Eyebrow, PrimaryBtn } from "../components/Flow";

const CATEGORIES = [
  { icon: Layers, key: "construction", title: "CONSTRUCTION", items: ["Cement", "Construction systems", "Prefabricated solutions", "Panels", "Insulation", "Waterproofing"] },
  { icon: Grid3X3, key: "finishes", title: "FINISHES", items: ["Ceramic", "Porcelain", "Stone", "Wall coverings", "Paint"] },
  { icon: Bath, key: "bathroom", title: "BATHROOM", items: ["Sanitaryware", "Washbasins", "Faucets", "Showers", "Bathroom furniture", "Mirrors", "Accessories"] },
  { icon: DoorOpen, key: "openings", title: "OPENINGS & ARCHITECTURAL ELEMENTS", items: ["Doors", "Windows", "Aluminium", "Glass", "Hardware", "Locks"] },
  { icon: ChefHat, key: "kitchen", title: "KITCHEN", items: ["Cabinets", "Countertops", "Sinks", "Faucets", "Kitchen components"] },
  { icon: Lightbulb, key: "lighting", title: "LIGHTING", items: ["Decorative lighting", "Architectural lighting", "Interior lighting", "Exterior lighting"] },
  { icon: Sofa, key: "furniture", title: "FURNITURE", items: ["Hotel furniture", "Residential furniture", "Outdoor furniture", "Contract furniture"] },
  { icon: TreePine, key: "exterior", title: "EXTERIOR", items: ["Outdoor finishes", "Pergolas", "Pool-related products", "Outdoor furniture", "Landscaping-related products"] },
];

export default function Products() {
  return (
    <main data-testid="products-page">
      <section className="bg-[#0B132B] py-20 text-white sm:py-24 grain-overlay relative">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <Eyebrow dark>Product Categories</Eyebrow>
            <h1 className="mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl" data-testid="products-headline">
              Colombian products for every layer of your project.
            </h1>
            <p className="mt-6 max-w-2xl text-sm leading-relaxed text-white/65 sm:text-base">
              We source by category, not by brand. For each project, we identify and qualify the Colombian manufacturers and suppliers best matched to your specifications, quality level and budget.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {CATEGORIES.map((c, i) => (
              <Reveal key={c.key} delay={(i % 4) * 80}>
                <div className="card-lift flex h-full flex-col border border-[#0B132B]/12 bg-white p-7" data-testid={`product-category-${c.key}`}>
                  <c.icon className="h-7 w-7 text-[#0D9488]" strokeWidth={1.5} />
                  <h2 className="mt-5 font-display text-sm font-bold leading-snug tracking-wide">{c.title}</h2>
                  <ul className="mt-4 space-y-2">
                    {c.items.map((it) => (
                      <li key={it} className="flex items-center gap-2 text-[13px] text-[#0B132B]/70">
                        <span className="h-1 w-1 shrink-0 bg-[#0D9488]" />
                        {it}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className="mt-16">
            <div className="flex flex-col items-start justify-between gap-8 border border-[#0B132B]/12 bg-[#0B132B] p-8 text-white sm:p-12 lg:flex-row lg:items-center" data-testid="products-cta-band">
              <div>
                <h2 className="font-display text-xl font-bold tracking-tight sm:text-2xl">
                  Looking for a specific product category?
                </h2>
                <p className="mt-2 max-w-xl text-sm text-white/60">
                  Send us your specifications or bill of quantities. We'll identify suitable Colombian supply options.
                </p>
              </div>
              <PrimaryBtn to="/contact" testid="products-cta-sourcing" light>REQUEST A PRODUCT SOURCING</PrimaryBtn>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
